/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "footballAppCRUD",
            "endpoint": "https://wqebtesa3m.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:b2b74010-0446-4d2e-9459-a86231c4e79b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_vEIlpcNFA",
    "aws_user_pools_web_client_id": "85oktbtqbclvccu07uh2p3m29",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "Auth": {
        "identityPoolId": "us-east-2:8bf044a9-8520-4819-9417-3f453015e7fd",
        "region": "us-east-2",
        "userPoolId": "us-east-2_z1UFB35uh",
        "userPoolWebClientId": "47fsorgp79659636gai3vj3g32",
        "oauth": {}
    },
    "Storage": {
        "bucket": "football-app-audio-bucket",
        "region": "us-east-2"
    }
};


export default awsmobile;
